var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsage = function SvgUsage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 21.5a9.2 9.2 0 0 1-3.703-.75 9.5 9.5 0 0 1-3.016-2.039 9.7 9.7 0 0 1-2.032-3.024A9.2 9.2 0 0 1 3 12q0-3.675 2.422-6.365T11.5 2.55v2.115q-2.787.38-4.585 2.467-1.8 2.087-1.8 4.868 0 3.063 2.161 5.224t5.224 2.16a7.3 7.3 0 0 0 3.309-.767q1.543-.767 2.537-2.044l1.831 1.077a9.46 9.46 0 0 1-3.321 2.82Q14.855 21.5 12.5 21.5m8.708-5.7-1.831-1.058q.244-.59.376-1.29T19.885 12q0-2.81-1.819-4.892T13.5 4.665V2.55q3.588.346 6.044 3.05Q22 8.307 22 12q0 1.042-.19 2.005a7.2 7.2 0 0 1-.602 1.795"
  })));
};
export default SvgUsage;